module.exports = __webpack_public_path__ + "static/media/EVC-fan-gif.11881de6.gif";